export default __webpack_public_path__ + "static/media/70.ad18af6a.jpg";